import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { CoreModule } from '@app/core';
import { SharedModule } from '@app/shared';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';

import { GridsterModule } from 'angular-gridster2';
import { MomentModule } from 'ngx-moment';
import { MaterialModule } from '@app/core/material.module';
import { MatButtonModule } from '@angular/material';
import { NgScrollbarModule } from 'ngx-scrollbar';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    CoreModule,
    SharedModule,
    HomeRoutingModule,
    GridsterModule,
    MomentModule,
    MatButtonModule,
    NgScrollbarModule
  ],
  declarations: [HomeComponent],
  providers: []
})
export class HomeModule {}
